module.exports = __webpack_public_path__ + "img/Minjeong_Kim@2x.8cbb9d3d.png";